export const ButtonPrimary = {
  transclude: true,

  bindings: {
    isInverse: '<',
    ngDisabled: '<',
    ngType: '@',
    size: '@',
    onClick: '&',
  },

  template: `
    <button class="btn btn-pill theme-btn text-white bg-cz-theme-secondary"
      ng-class="{
        'btn-sm': $ctrl.size === 'sm',
        'btn-md': $ctrl.size === 'md',
        'btn-lg': $ctrl.size === 'lg' || !$ctrl.size,
        'theme-btn--inverse': $ctrl.isInverse
      }"
      type="{{ $ctrl.ngType || 'button' }}"
      ng-click="$ctrl.onClick()"
      ng-disabled="$ctrl.ngDisabled"
      ng-transclude>
    </button>`,
};



// WEBPACK FOOTER //
// ./src/components/Button/ButtonPrimary.js